import React, { useState } from 'react';

import LazyLoad from 'react-lazyload';

import { IKImage } from '../IKImage';

interface LazyLoadImageProps {
  offset?: number;
  placeholderQuality?: number;
  placeholderBlur?: number;
  path: string;
  transformation?: any[] | null;
  imageWrapperClass?: string;
  objectFitPolyfill?: string;
  [key: string]: any;
}

const LazyLoadImage: React.FC<LazyLoadImageProps> = ({
  offset = 300,
  placeholderQuality = 50,
  placeholderBlur = 10,
  path,
  transformation = null,
  srcset = [],
  imageWrapperClass,
  sizes = null,
  objectFitPolyfill,
  ...props
}) => {
  const [removedPlaceholder, setRemovedPlaceholder] = useState(false);

  const updatedSrcset = srcset.map((item) => ({
    ...item,
    quality: placeholderQuality,
    blur: placeholderBlur,
  }));

  const removePlaceholder = () => {
    setRemovedPlaceholder(true);

    if (window?.objectFitPolyfill && objectFitPolyfill) {
      window.objectFitPolyfill();
    }
  };

  return (
    <>
      {!removedPlaceholder && (
        <IKImage
          path={path}
          transformation={transformation}
          srcset={updatedSrcset}
          sizes={sizes}
          {...props}
        />
      )}
      <LazyLoad offset={offset} className={imageWrapperClass}>
        <IKImage
          path={path}
          transformation={transformation}
          srcset={srcset}
          sizes={sizes}
          onLoad={removePlaceholder}
          onError={removePlaceholder}
          data-object-fit={objectFitPolyfill}
          {...props}
        />
      </LazyLoad>
    </>
  );
};

export default LazyLoadImage;
